module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAAAAACov6uJAAAAh0lEQVQoz2P4jwTuM8gjcxnwyn2+DwFvYXJPoQJ/Gf7PZ4CAfJicPlTgPUiOhR8EKmByNmAuVM4fm338tJb7cwgitwuLXALTEpBcOUMFplw7A1M/g1wBA8M0LPa1Q7w8Datb2pGkMNzZjpDCkPvfPg2n/5DBMJKz3o8FcEPkcACg3HZ7HOAzAN87AutynOAeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/images/icon-flpln.png
// module id = 643
// module chunks = 0